import { WebSale } from "../models/webSale";
import http from "../http/http-config";

export default new class WebSalesOffersSettingService {
    getWebSalesOffersSettings(urlSite: string, urlSiteVw: string): Promise<WebSale | null> {
            return http.get<WebSale>("WebSalesOffersSettings/GetWebSalesOffersSettings", {
                params: {
                    urlSite,
                    urlSiteVw
            }
        }).then(response => response.data);
    }
}